import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-refresh",
  templateUrl: "./med-icon-refresh.component.html",
})
export class MedIconRefreshComponent extends SvgMixinComponent {}
